"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

require("./index.css");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Select = function Select(_ref) {
  var placeholder = _ref.placeholder,
      value = _ref.value,
      onChange = _ref.onChange,
      options = _ref.options,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? '˯' : _ref$icon;
  var selectRef = (0, _react.useRef)(null);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "form--group"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "form--input-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("select", {
    value: value,
    ref: selectRef,
    onChange: onChange,
    className: "form--input",
    onClick: function onClick() {
      return selectRef.current.classList.add('selected');
    }
  }, /*#__PURE__*/_react["default"].createElement("option", {
    value: "",
    disabled: true
  }, placeholder), options.map(function (option, index) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      value: option.value || option,
      key: "option-".concat(index)
    }, option.label || option);
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "form--input-icon-container"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "form--input-icon"
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: "angle-down"
  })))));
};

var _default = Select;
exports["default"] = _default;